const uz = {
    meta: {
        title: "Ulgurji savdo naqdsiz hisob-kitob 2026: o'tish rejasi",
        description:
            "1-iyuldan markirovka qilinadigan mahsulot ulgurjisida hisob-kitob faqat naqdsiz. To'lov, ESF va qarzdorlik nazoratini qayta qurish: narx, muddat va qaytim.",
        keywords: [
            "ulgurji savdo naqdsiz hisob-kitob 2026",
            "markirovka ulgurji savdo qoidalari",
            "elektron hisob-faktura ESF qanday yuboriladi",
            "distribyutor uchun hujjat aylanishi",
            "1C va CRM integratsiyasi",
            "debitor qarzdorlik nazorati dastur",
        ],
    },
    h1: "Ulgurjida naqd pul taqiqi: to'lov va hujjat oqimini qanday qayta qurish kerak",
    lead:
        "2026-yil 1-iyuldan markirovka qilinadigan mahsulot bilan ulgurji savdoda hisob-kitob faqat naqdsiz shaklda, bank hisob raqamlari orqali o'tkaziladi. Distribyutor uchun bu butun to'lov modeli va qarzdorlik nazoratining almashuvi. Quyida — nima o'zgaradi, qancha turadi va qaytim qanday hisoblanadi.",
    category: "Qonun va muvofiqlik",
    readingTime: "9 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Naqd pul distribyutsiyada faqat to'lov usuli emas edi. U bir vaqtning o'zida qarzdorlik nazorati vositasi ham edi: pul kelmasa, mashina yo'lga chiqmasdi. Naqd yo'qolgach, bu nazorat ham yo'qoladi va uni boshqa narsa bilan almashtirish kerak bo'ladi.",
        },
        {
            type: "p",
            text:
                "Maqola distribyutor va ulgurji sotuvchi uchun yozilgan. Unda qonun talabi, yangi jarayon sxemasi, tizim narxi va qaytimning ochiq hisobi bor.",
        },

        { type: "h2", text: "1-iyuldan ulgurjida nima o'zgaradi?" },
        {
            type: "p",
            text:
                "Vazirlar Mahkamasining 2025-yil 23-maydagi ПП-190 qaroriga ko'ra 2026-yil 1-iyuldan markirovka qilinadigan mahsulot bilan ulgurji savdoda hisob-kitob faqat naqdsiz shaklda, bank hisob raqamlari orqali amalga oshiriladi. Shu sanadan markirovka kodi chakana sotuvda chekda ham majburiy aks etadi.",
        },
        {
            type: "p",
            text:
                "Elektron hisob-faktura O'zbekistonda allaqachon majburiy va uning tekshiruvi bo'yicha avtomatik nazorat kuchaytirildi. Elektron hujjat aylanishi operatorlari o'rtasida rouming ishlaydi — ya'ni mijozingiz boshqa operatorda bo'lsa ham hujjat yetib boradi.",
        },
        {
            type: "p",
            text:
                "Nazorat tomonida ham o'zgarish bor. 2026-yil 1-yanvardan markirovka buzilishlari masofadan, soliq organlari axborot tizimi orqali aniqlanadi, 1-sentyabrdan esa buzilish «yuqori» soliq riski omili hisoblanadi.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Naqd yo'qolgach paydo bo'ladigan asosiy risk" },
        {
            type: "p",
            text:
                "Ko'p distribyutor «naqdsizga o'tamiz, buxgalter bank ko'chirmasini ko'radi» deb o'ylaydi. Amalda muammo boshqa joyda: pul kelgani ko'rinadi, lekin u qaysi yuk xati uchun kelgani ko'rinmaydi.",
        },
        {
            type: "p",
            text:
                "Naqd bilan ishlaganda ekspeditor pulni aniq bir yetkazish uchun olardi. Bank o'tkazmasida esa diler bir summani yuboradi va u uchta eski hisob-fakturaning qismini yopadi. Buni qo'lda ajratish — bu o'sha soatlar, qaysiki oy oxirida g'oyib bo'ladi.",
        },
        {
            type: "list",
            items: [
                "To'lov keldi, lekin qaysi bitimga tegishli ekani noaniq — qarzdorlik hisobotining aniqligi yo'qoladi.",
                "Diler qisman to'laydi va qaysi hisob-faktura yopilganini o'zi tanlaydi — sizda boshqacha yozilgan bo'lishi mumkin.",
                "Hisob-faktura raqami to'lov izohida ko'rsatilmaydi — solishtirish qo'lda bo'ladi.",
                "Yetkazib berish to'lov tasdig'ini kutadi, chunki ekspeditor endi pul olib kelmaydi.",
                "Sotuv menejeri mijozning qarzini real vaqtda ko'rmaydi va yangi buyurtmani baribir qabul qiladi.",
            ],
        },

        { type: "h2", text: "Eski va yangi oqim: yonma-yon taqqoslash" },
        {
            type: "table",
            head: ["Bosqich", "Naqd modeli", "Naqdsiz model"],
            rows: [
                ["Buyurtma", "Telefon yoki messenjer, qog'oz yuk xati", "Tizimda buyurtma, qarz limiti avtomatik tekshiriladi"],
                ["To'lov", "Ekspeditor naqd olib keladi", "Bank o'tkazmasi, ba'zan qisman va kechikib"],
                ["Hujjat", "Qog'oz hisob-faktura, imzo", "Elektron hisob-faktura, rouming orqali yetkaziladi"],
                ["Solishtirish", "Kassa daftari bilan qo'lda", "Bank ko'chirmasi va ESF avtomatik solishtiriladi"],
                ["Qarzdorlik", "Ekspeditor bilgan, hisobotda kech ko'ringan", "Muddat bo'yicha hisobot, real vaqtda"],
                ["Nazorat", "Pul kelmasa — yuk ketmaydi", "Limit va bloklash qoidasi tizimda yoziladi"],
            ],
        },
        {
            type: "p",
            text:
                "O'ng ustun tayyor holda kelmaydi — uni qurish kerak. Aynan shu sabab 1-iyul distribyutorlar uchun buxgalteriya sanasi emas, operatsion loyihaning muddati. Jadvaldagi har bir qator alohida ish: shartnoma shartini o'zgartirish, hujjat shaklini almashtirish, menejer odatini qayta qurish. Ularni parallel qilish mumkin, lekin o'tkazib yuborish mumkin emas.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Buxgalter qancha soat yo'qotadi?" },
        {
            type: "p",
            text:
                "Bu raqamni taxmin qilmang — bir oy davomida o'lchang. Amaliyotimizda hisob quyidagicha chiqadi.",
        },
        {
            type: "ol",
            items: [
                "Oyiga nechta to'lov keladi? 80 ta diler va har biridan o'rtacha 4 ta o'tkazma bo'lsa — 320 ta to'lov.",
                "Bitta to'lovni hisob-faktura bilan solishtirishga o'rtacha 3 daqiqa ketadi: 320 × 3 = 960 daqiqa ≈ 16 soat.",
                "Nomuvofiq qolgan to'lovlar bo'yicha diler bilan yozishmalar — yana taxminan 10 soat.",
                "Qarzdorlik hisobotini yig'ish va menejerlarga tarqatish — oyiga 8 soat.",
                "Jami taxminan 34 soat. Soat tannarxi 10 mln so'mlik maoshda 59 500 so'm bo'lsa, bu oyiga taxminan 2 mln so'm.",
            ],
        },
        {
            type: "p",
            text:
                "Bu faqat to'g'ridan-to'g'ri xarajat. Bilvosita xarajat kattaroq: hisobot kech kelgani uchun qabul qilingan noto'g'ri qarorlar.",
        },

        { type: "h2", text: "To'lov kechikishini qanday qisqartirish mumkin?" },
        {
            type: "p",
            text:
                "Distribyutsiyada asosiy ko'rsatkich — pulning o'rtacha qaytish muddati, ya'ni yuk ketgan kundan pul kelgan kungacha o'tgan kunlar soni. Uni tizim uchta mexanizm bilan qisqartiradi.",
        },
        {
            type: "list",
            items: [
                "Qarz limiti: mijozning ochiq qarzi belgilangan chegaradan oshsa, yangi buyurtma avtomatik to'xtaydi. Bu menejerning qaroriga bog'liq bo'lmaydi.",
                "Avtomatik eslatma: muddat tugashidan uch kun oldin mijozga va menejerga xabar ketadi.",
                "Muddat bo'yicha hisobot: 0–30, 31–60, 61–90 va 90+ kunlik guruhlar. Rahbar qaysi guruh o'sayotganini haftasiga bir marta ko'radi.",
            ],
        },
        {
            type: "p",
            text:
                "Qaytish muddatini atigi besh kunga qisqartirish kapital aylanishini sezilarli o'zgartiradi. Oylik aylanmasi 3 mlrd so'm bo'lgan distribyutorda bu taxminan 500 mln so'mlik pulning muzlashdan chiqishi degani. Bu foyda emas, lekin bu kredit olmaslik imkoni.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Tizim qancha turadi?" },
        {
            type: "p",
            text:
                "Distribyutor uchun yechim odatda bosqichma-bosqich quriladi. Quyida boshlang'ich narxlar va ish hajmi.",
        },
        {
            type: "table",
            head: ["Bosqich", "Nima kiradi", "Muddat", "Narx"],
            rows: [
                [
                    "CRM konturi",
                    "Mijozlar bazasi, buyurtma, qarz limiti, eslatma va hisobotlar",
                    "6–10 hafta",
                    "18 mln so'mdan",
                ],
                [
                    "To'lov va ESF solishtiruvi",
                    "Bank ko'chirmasini yuklash, hisob-faktura bilan avtomatik moslashtirish",
                    "4–6 hafta",
                    "15 mln so'mdan",
                ],
                [
                    "Ombor va logistika konturi",
                    "Qoldiq, yig'ish, marshrut, yetkazish tasdig'i",
                    "3–5 oy",
                    "45 mln so'mdan",
                ],
                [
                    "Yagona ERP",
                    "Ombor, sotuv, moliya va hisobot bitta bazada, 1C bilan integratsiya",
                    "4–8 oy",
                    "40 mln so'mdan",
                ],
                ["Qo'llab-quvvatlash", "Kuzatuv, zaxira nusxa, kichik o'zgarishlar", "oylik", "3,5 mln so'mdan / oyiga"],
            ],
        },
        {
            type: "p",
            text:
                "Narxga kirmaydi: EDO operatori obunasi, bank integratsiyasi uchun bank tomonidagi tariflar, server to'lovlari va xodimlarni o'qitishga ketadigan ish vaqti.",
        },

        { type: "h2", text: "Qaytim qanday hisoblanadi?" },
        {
            type: "ol",
            items: [
                "Yuqoridagi hisobdan qo'l mehnati: oyiga taxminan 2 mln so'm.",
                "Tizim solishtirishning 80% ini oladi deb faraz qiling: oyiga 1,6 mln so'm tejaladi.",
                "Ikkinchi manba — umidsiz qarz. Oylik aylanmaning 0,5% i 3 mlrd so'mlik aylanmada 15 mln so'm.",
                "Limit va eslatma shu yo'qotishning uchdan birini oldini olsa, oyiga 5 mln so'm qo'shiladi.",
                "Jami taxminan 6,6 mln so'm / oy. 18 mln so'mlik CRM konturi shu hisobda 3 oyga yaqin muddatda qaytadi.",
            ],
        },
        {
            type: "p",
            text:
                "Raqamlar sizniki bo'lishi kerak. Agar dilerlaringiz o'z vaqtida to'lasa va umidsiz qarz deyarli bo'lmasa, hisobning ikkinchi qismi tushib qoladi va qaytim muddati uzayadi.",
        },

        { type: "h2", text: "Hech narsa qilmaslikning narxi" },
        {
            type: "list",
            items: [
                "Naqd qabul qilishni davom ettirish markirovka qilinadigan mahsulot bo'yicha bitimni rasmiylashtirish imkonini yo'qotadi.",
                "Qo'lda solishtirish oyiga bir necha o'nlab soat oladi va bu soat har oy qaytariladi.",
                "Qarzdorlik hisoboti kech kelsa, yangi yuk qarzdor mijozga ketadi — yo'qotish o'sadi.",
                "Ma'lumot mos kelmasa, bu masofaviy nazoratda ko'rinadi va kompaniya profiliga ta'sir qiladi.",
                "Butun jarayon bitta buxgalterning boshida saqlansa, u ta'tilga chiqishi bilan to'lov nazorati to'xtaydi.",
            ],
        },

        { type: "h2", text: "Bu loyiha qachon sizga mos emas" },
        {
            type: "list",
            items: [
                "Markirovka qilinadigan mahsulot bilan ishlamasangiz va allaqachon naqdsiz ishlasangiz — shoshilinch loyiha kerak emas.",
                "Dilerlaringiz soni o'nga yaqin bo'lsa — jadval va bank kabineti hali yetarli, CRM narxi o'zini oqlamaydi.",
                "Narx siyosati va chegirmalar yozilmagan bo'lsa — tizim ularni qat'iylashtira olmaydi, avval qoidani yozing.",
                "Menejerlar tizimga buyurtma kiritishga tayyor bo'lmasa — ma'lumot to'liq bo'lmaydi va hisobot yolg'on chiqadi.",
                "Yaqin oylarda assortiment yoki biznes modelini butunlay o'zgartirmoqchi bo'lsangiz — kutgan ma'qul.",
            ],
        },

        { type: "h2", text: "Sakkiz haftalik o'tish rejasi" },
        {
            type: "ol",
            items: [
                "1–2-hafta: dilerlar bilan shartnomalarni ko'rib chiqing, to'lov shartlari va muddatlarini yozma qayd eting.",
                "3-hafta: to'lov izohida hisob-faktura raqamini ko'rsatish qoidasini mijozlarga yetkazing — bu solishtirishni ikki barobar tezlashtiradi.",
                "4-hafta: bir oylik solishtirish soatlarini o'lchang. Qaytim hisobi shu raqamga tayanadi.",
                "5-hafta: qarz limiti qoidasini yozing: kimga qancha va qaysi muddatga.",
                "6–7-hafta: CRM konturini ishga tushiring, bank ko'chirmasi va ESF ni ulang.",
                "8-hafta: menejerlarni o'qiting va birinchi oyni qo'lda hamda tizimda parallel yuriting.",
            ],
        },
        {
            type: "p",
            text:
                "Parallel oyni o'tkazib yubormang. Aynan o'sha oyda tizim hisobi bilan buxgalter hisobi orasidagi farq ochiladi va uni tuzatish keyinchalik ancha qimmatga tushadi.",
        },
    ],

    faq: [
        {
            q: "Ulgurjida naqd pul qachondan taqiqlanadi?",
            a: "2026-yil 1-iyuldan. ПП-190 qaroriga ko'ra markirovka qilinadigan mahsulot bilan ulgurji savdoda hisob-kitob faqat naqdsiz shaklda, bank hisob raqamlari orqali amalga oshiriladi. Ya'ni taqiq butun ulgurjiga emas, markirovka qilinadigan toifaga tegishli. Tovar ro'yxatingizni tekshirib, qaysi pozitsiyalar bu talabga tushishini oldindan aniqlang.",
        },
        {
            q: "Elektron hisob-faktura mijozim boshqa operatorda bo'lsa yetib boradimi?",
            a: "Ha. Elektron hujjat aylanishi operatorlari o'rtasida rouming ishlaydi, shuning uchun mijoz boshqa operatorda bo'lsa ham hujjat yetib boradi. Amalda e'tibor beriladigan narsa boshqa: hujjatdagi rekvizitlar va pozitsiyalar sizning tizimingizdagi ma'lumot bilan bir xil bo'lishi kerak, aks holda solishtirish qo'lda qoladi.",
        },
        {
            q: "To'lovni hisob-faktura bilan avtomatik solishtirish qanday ishlaydi?",
            a: "Tizim bank ko'chirmasini yuklaydi va har bir to'lovni ochiq hisob-fakturalarga moslashtiradi: summa, sana va to'lov izohidagi hujjat raqami bo'yicha. Aniq moslik topilsa, hisob-faktura avtomatik yopiladi. Nomuvofiq qolganlari alohida ro'yxatga tushadi va buxgalter faqat shular bilan ishlaydi. Amalda bu qo'l mehnatining katta qismini olib tashlaydi.",
        },
        {
            q: "Mavjud 1C ni almashtirish kerakmi?",
            a: "Odatda yo'q. 1C buxgalteriya konturi sifatida qoladi, ustiga sotuv, qarzdorlik va logistika uchun CRM yoki ERP konturi quriladi. Ikkalasi integratsiya orqali ma'lumot almashadi. Bu hammasini noldan qurishdan sezilarli arzonroq tushadi, lekin konfiguratsiyangiz qanchalik o'zgartirilgani va integratsiya nuqtalari sonini oldindan tekshirish kerak.",
        },
        {
            q: "Loyiha qancha vaqt oladi?",
            a: "CRM konturi — mijozlar bazasi, buyurtma, qarz limiti va hisobotlar — odatda 6–10 hafta oladi va 18 mln so'mdan boshlanadi. To'lov hamda ESF solishtiruvi 4–6 hafta qo'shadi. Ombor va logistikani ham qamrab olsa, muddat 3–5 oyga, yagona ERP holatida esa 4–8 oyga cho'ziladi.",
        },
        {
            q: "Qarz limitini qanday belgilash kerak?",
            a: "Amaliy qoida: limit mijozning o'rtacha oylik xaridi va uning to'lov tarixi asosida belgilanadi. Yangi dilerga kichik limit va qisqa muddat beriladi, muntazam o'z vaqtida to'laganlarga esa u bosqichma-bosqich oshiriladi. Qoidani avval qog'ozda yozing — tizim faqat yozilgan qoidani bajara oladi.",
        },
    ],

    cta: {
        h: "To'lov va hujjat oqimingizni bepul ko'rib chiqamiz",
        p:
            "Dilerlar soni, to'lov shartlari va hozirgi dasturlaringizni ko'rib, naqdsizga o'tish uchun nima kerakligini va taxminiy byudjetni aytamiz. Mavjud tizim yetarli bo'lsa, buni ham to'g'ridan-to'g'ri aytamiz.",
        button: "Bepul konsultatsiya olish",
    },

    images: [
        {
            src: "/assets/img/blog/ulgurji-naqdsiz-cover.webp",
            alt: "Ulgurji ombor va dilerlar to'lov holati ko'rsatilgan planshet ekrani",
            caption: "Naqd yo'qolgach, nazorat ekranga ko'chadi",
            prompt:
                "Wholesale warehouse scene: pallets of boxed goods in the foreground, a manager with a tablet showing a payment-status dashboard where several dealer rows are marked paid and overdue; industrial daylight, muted blue-grey palette, no readable brands, 16:9",
        },
        {
            src: "/assets/img/blog/ulgurji-naqdsiz-oqim.webp",
            alt: "Naqd asosidagi eski oqim va naqdsiz, ESF asosidagi yangi oqimning taqqoslanishi",
            caption: "Yuqorida — eski model, pastda — naqdsiz va elektron hujjatli model",
            prompt:
                "Process diagram comparing two flows: top row before with cash handover, paper waybill and manual ledger; bottom row after with bank transfer, e-invoice, automatic reconciliation in CRM and debt aging report; clean flat vector, red-to-green transition accent, 16:9",
        },
        {
            src: "/assets/img/projects/logistatrans.webp",
            alt: "LogistaTrans tizimi — arizalar, marshrutlar va hujjatlar bitta oynada",
            caption: "Distribyutsiya jarayoni raqamlashtirilgan real loyiha misoli",
        },
        {
            src: "/assets/img/blog/ulgurji-naqdsiz-qarzdorlik.webp",
            alt: "Debitor qarzdorlikning muddat bo'yicha taqsimoti va o'rtacha to'lov kunlari ko'rsatkichi",
            caption: "Muddat bo'yicha hisobot: pul qayerda qolib ketayotgani shu yerda ko'rinadi",
            prompt:
                "Analytics panel illustration: accounts-receivable aging chart with buckets 0-30, 31-60, 61-90 and 90+ days, plus a KPI tile showing average days sales outstanding; minimal light dashboard, blue and amber accents, no logos, 16:9",
        },
    ],

    relatedServices: ["crm-tizimlar", "erp-tizimlar", "biznes-avtomatlashtirish"],
    relatedPosts: ["biznesni-raqamlashtirish-talablari-2026", "markirovka-kodi-chekda-2026", "shaxsiy-malumotlar-qonuni-sayt"],
};

const ru = {
    meta: {
        title: "Опт только безналично 2026: как перестроить платежи",
        description:
            "С 1 июля расчёты в опте маркируемой продукцией только безналичные. Перестройка платежей, ЭСФ и контроля задолженности: цена, сроки и расчёт окупаемости.",
        keywords: [
            "оптовая торговля только безналичный расчёт Узбекистан 2026",
            "безналичные расчёты маркируемая продукция",
            "ЭСФ и ЭДО для дистрибьютора",
            "интеграция 1С с CRM Узбекистан",
            "контроль дебиторской задолженности программа",
            "правила оптовой торговли маркировка",
        ],
    },
    h1: "Запрет наличных в опте: как перестроить платежи и документооборот",
    lead:
        "С 1 июля 2026 года расчёты в оптовой торговле маркируемой продукцией проводятся только в безналичной форме, через банковские счета. Для дистрибьютора это смена всей платёжной модели и контроля задолженности. Разбираем, что меняется, сколько стоит и как считать окупаемость.",
    category: "Закон и комплаенс",
    readingTime: "9 минут",

    body: [
        {
            type: "p",
            text:
                "Наличные в дистрибуции были не только способом оплаты. Одновременно они служили инструментом контроля долга: нет денег — машина не выезжает. Когда наличные уходят, этот контроль исчезает, и его нужно чем-то заменить.",
        },
        {
            type: "p",
            text:
                "Статья написана для дистрибьюторов и оптовых продавцов. В ней — требование закона, схема нового процесса, стоимость системы и открытый расчёт окупаемости.",
        },

        { type: "h2", text: "Что меняется в опте с 1 июля?" },
        {
            type: "p",
            text:
                "По постановлению ПП-190 от 23 мая 2025 года с 1 июля 2026 года расчёты в оптовой торговле маркируемой продукцией проводятся только в безналичной форме, через банковские счета. С этой же даты код маркировки обязателен в чеке при розничной продаже.",
        },
        {
            type: "p",
            text:
                "Электронный счёт-фактура в Узбекистане уже обязателен, а автоматический контроль по нему усилен. Между операторами электронного документооборота работает роуминг — то есть документ дойдёт, даже если клиент подключён к другому оператору.",
        },
        {
            type: "p",
            text:
                "Изменился и надзор. С 1 января 2026 года нарушения маркировки выявляются дистанционно, через информационную систему налоговых органов, а с 1 сентября нарушение считается фактором «высокого» налогового риска.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Главный риск, который появляется без наличных" },
        {
            type: "p",
            text:
                "Многие дистрибьюторы рассуждают так: перейдём на безнал, бухгалтер посмотрит выписку. На практике проблема в другом: видно, что деньги пришли, но не видно, за какую накладную.",
        },
        {
            type: "p",
            text:
                "При работе с наличными экспедитор забирал деньги за конкретную поставку. В банковском переводе дилер отправляет одну сумму, и она частично закрывает три старых счёта-фактуры. Разнести это вручную — те самые часы, которые исчезают в конце месяца.",
        },
        {
            type: "list",
            items: [
                "Платёж пришёл, но непонятно, к какой сделке он относится — точность отчёта по долгам теряется.",
                "Дилер платит частично и сам решает, какой документ закрывает, — у вас может быть записано иначе.",
                "Номер счёта-фактуры не указан в назначении платежа — сверка остаётся ручной.",
                "Отгрузка ждёт подтверждения оплаты, потому что экспедитор больше не привозит деньги.",
                "Менеджер не видит долг клиента в реальном времени и всё равно принимает новый заказ.",
            ],
        },

        { type: "h2", text: "Старый и новый процесс: сравнение" },
        {
            type: "table",
            head: ["Этап", "Модель с наличными", "Безналичная модель"],
            rows: [
                ["Заказ", "Телефон или мессенджер, бумажная накладная", "Заказ в системе, лимит долга проверяется автоматически"],
                ["Оплата", "Экспедитор привозит наличные", "Банковский перевод, часто частичный и с задержкой"],
                ["Документ", "Бумажная счёт-фактура и подпись", "Электронный счёт-фактура, доставка через роуминг"],
                ["Сверка", "Вручную по кассовой книге", "Выписка и ЭСФ сверяются автоматически"],
                ["Задолженность", "Знал экспедитор, в отчёт попадала поздно", "Отчёт по срокам, в реальном времени"],
                ["Контроль", "Нет денег — нет отгрузки", "Лимит и правило блокировки записаны в системе"],
            ],
        },
        {
            type: "p",
            text:
                "Правая колонка не появляется сама — её нужно построить. Именно поэтому 1 июля для дистрибьютора не бухгалтерская дата, а срок операционного проекта.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Сколько часов теряет бухгалтер?" },
        {
            type: "p",
            text:
                "Эту цифру не угадывайте — измерьте за месяц. В нашей практике расчёт выглядит так.",
        },
        {
            type: "ol",
            items: [
                "Сколько платежей приходит в месяц? При 80 дилерах и в среднем 4 переводах от каждого — 320 платежей.",
                "Сверка одного платежа со счетами-фактурами занимает около 3 минут: 320 × 3 = 960 минут ≈ 16 часов.",
                "Переписка с дилерами по неразнесённым платежам — ещё примерно 10 часов.",
                "Сбор отчёта по задолженности и рассылка менеджерам — 8 часов в месяц.",
                "Итого около 34 часов. При окладе 10 млн сум час стоит 59 500 сум, значит, это примерно 2 млн сум в месяц.",
            ],
        },
        {
            type: "p",
            text:
                "Это только прямые затраты. Косвенные больше: неверные решения, принятые из-за того, что отчёт пришёл с опозданием.",
        },

        { type: "h2", text: "Как сократить срок возврата денег?" },
        {
            type: "p",
            text:
                "Главный показатель в дистрибуции — средний срок возврата денег, то есть число дней от отгрузки до поступления оплаты. Система сокращает его тремя механизмами.",
        },
        {
            type: "list",
            items: [
                "Кредитный лимит: если открытый долг клиента превышает порог, новый заказ автоматически останавливается. Это перестаёт зависеть от решения менеджера.",
                "Автоматическое напоминание: за три дня до срока уведомление уходит клиенту и менеджеру.",
                "Отчёт по срокам: группы 0–30, 31–60, 61–90 и 90+ дней. Руководитель раз в неделю видит, какая группа растёт.",
            ],
        },
        {
            type: "p",
            text:
                "Сокращение срока возврата всего на пять дней заметно меняет оборачиваемость капитала. У дистрибьютора с оборотом 3 млрд сум в месяц это примерно 500 млн сум, которые перестают быть замороженными. Это не прибыль, но это возможность не брать кредит.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Сколько стоит система?" },
        {
            type: "p",
            text:
                "Решение для дистрибьютора обычно строится поэтапно. Ниже стартовые цены и объём работ.",
        },
        {
            type: "table",
            head: ["Этап", "Что входит", "Срок", "Цена"],
            rows: [
                [
                    "Контур CRM",
                    "База клиентов, заказы, кредитный лимит, напоминания и отчёты",
                    "6–10 недель",
                    "от 18 млн сум",
                ],
                [
                    "Сверка платежей и ЭСФ",
                    "Загрузка банковской выписки, автоматическое сопоставление со счетами-фактурами",
                    "4–6 недель",
                    "от 15 млн сум",
                ],
                [
                    "Контур склада и логистики",
                    "Остатки, сборка, маршруты, подтверждение доставки",
                    "3–5 месяцев",
                    "от 45 млн сум",
                ],
                [
                    "Единая ERP",
                    "Склад, продажи, финансы и отчётность в одной базе, интеграция с 1С",
                    "4–8 месяцев",
                    "от 40 млн сум",
                ],
                ["Поддержка", "Мониторинг, резервные копии, мелкие доработки", "ежемесячно", "от 3,5 млн сум в месяц"],
            ],
        },
        {
            type: "p",
            text:
                "В цену не входят: подписка оператора ЭДО, тарифы банка за интеграцию, оплата серверов и рабочее время сотрудников на обучение.",
        },

        { type: "h2", text: "Как считать окупаемость?" },
        {
            type: "ol",
            items: [
                "Ручная работа из расчёта выше: примерно 2 млн сум в месяц.",
                "Допустим, система берёт на себя 80% сверки: экономия 1,6 млн сум в месяц.",
                "Второй источник — безнадёжный долг. Даже 0,5% месячного оборота при 3 млрд сум — это 15 млн сум.",
                "Если лимит и напоминания предотвращают треть этих потерь, добавляется 5 млн сум в месяц.",
                "Итого около 6,6 млн сум в месяц. Контур CRM за 18 млн сум при таком расчёте окупается примерно за 3 месяца.",
            ],
        },
        {
            type: "p",
            text:
                "Цифры должны быть вашими. Если дилеры платят вовремя и безнадёжных долгов почти нет, вторая часть расчёта отпадает, а срок окупаемости удлиняется.",
        },

        { type: "h2", text: "Цена бездействия" },
        {
            type: "list",
            items: [
                "Продолжать принимать наличные — значит терять возможность оформить сделку по маркируемой продукции.",
                "Ручная сверка забирает десятки часов ежемесячно, и эти часы повторяются каждый месяц.",
                "Если отчёт по долгам приходит с опозданием, новая отгрузка уезжает к должнику и потери растут.",
                "Расхождение данных видно при дистанционном контроле и влияет на профиль компании.",
                "Когда весь процесс держится в голове одного бухгалтера, контроль оплат останавливается вместе с его отпуском.",
            ],
        },

        { type: "h2", text: "Когда этот проект вам не подходит" },
        {
            type: "list",
            items: [
                "Вы не работаете с маркируемой продукцией и уже давно ведёте расчёты безналично — срочный проект не нужен.",
                "Дилеров около десяти — таблицы и банковского кабинета пока хватает, CRM себя не окупит.",
                "Ценовая политика и скидки не описаны — система не сможет их закрепить, сначала напишите правило.",
                "Менеджеры не готовы вносить заказы в систему — данные будут неполными, а отчёт недостоверным.",
                "В ближайшие месяцы вы планируете полностью сменить ассортимент или бизнес-модель — лучше подождать.",
            ],
        },

        { type: "h2", text: "План перехода на восемь недель" },
        {
            type: "ol",
            items: [
                "Недели 1–2: пересмотрите договоры с дилерами, письменно зафиксируйте условия и сроки оплаты.",
                "Неделя 3: доведите до клиентов правило указывать номер счёта-фактуры в назначении платежа — это вдвое ускорит сверку.",
                "Неделя 4: измерьте часы на сверку за месяц. Расчёт окупаемости опирается на эту цифру.",
                "Неделя 5: пропишите правило кредитного лимита: кому, сколько и на какой срок.",
                "Недели 6–7: запустите контур CRM, подключите банковскую выписку и ЭСФ.",
                "Неделя 8: обучите менеджеров и проведите первый месяц параллельно — вручную и в системе.",
            ],
        },
        {
            type: "p",
            text:
                "Не пропускайте параллельный месяц. Именно в нём вскрывается разница между учётом системы и учётом бухгалтера, а исправлять её позже значительно дороже.",
        },
    ],

    faq: [
        {
            q: "С какого числа в опте запрещены наличные?",
            a: "С 1 июля 2026 года. По постановлению ПП-190 расчёты в оптовой торговле маркируемой продукцией проводятся только в безналичной форме, через банковские счета. То есть запрет касается не всего опта, а маркируемых категорий. Проверьте свою товарную матрицу и заранее определите, какие позиции попадают под требование.",
        },
        {
            q: "Дойдёт ли ЭСФ, если клиент у другого оператора?",
            a: "Да. Между операторами электронного документооборота работает роуминг, поэтому документ дойдёт и при подключении клиента к другому оператору. На практике важнее другое: реквизиты и позиции в документе должны совпадать с данными в вашей системе, иначе сверка всё равно останется ручной и время бухгалтера не освободится.",
        },
        {
            q: "Как работает автоматическая сверка платежей с ЭСФ?",
            a: "Система загружает банковскую выписку и сопоставляет каждый платёж с открытыми счетами-фактурами по сумме, дате и номеру документа в назначении платежа. При точном совпадении счёт-фактура закрывается автоматически. Всё, что не сошлось, попадает в отдельный список, и бухгалтер работает только с ним.",
        },
        {
            q: "Нужно ли менять существующую 1С?",
            a: "Обычно нет. 1С остаётся бухгалтерским контуром, а поверх строится контур CRM или ERP для продаж, задолженности и логистики. Они обмениваются данными через интеграцию. Это заметно дешевле, чем делать всё заново, но степень доработки вашей конфигурации и число точек интеграции стоит проверить заранее.",
        },
        {
            q: "Сколько длится проект?",
            a: "Контур CRM — база клиентов, заказы, кредитный лимит и отчёты — обычно занимает 6–10 недель и начинается от 18 млн сум. Сверка платежей и ЭСФ добавляет 4–6 недель. Если охватывать склад и логистику, срок растёт до 3–5 месяцев, а в варианте единой ERP — до 4–8 месяцев.",
        },
        {
            q: "Как определить кредитный лимит?",
            a: "Практическое правило: лимит считается от средней месячной закупки клиента и его платёжной истории. Новому дилеру дают небольшой лимит и короткий срок, а тем, кто стабильно платит вовремя, его повышают постепенно. Сначала опишите правило на бумаге — система умеет исполнять только описанное правило.",
        },
    ],

    cta: {
        h: "Бесплатно разберём ваш платёжный поток и документооборот",
        p:
            "Посмотрим на число дилеров, условия оплаты и текущие программы, затем скажем, что нужно для перехода на безнал и каким будет ориентировочный бюджет. Если существующей системы достаточно, скажем прямо.",
        button: "Получить консультацию",
    },

    images: [
        {
            src: "/assets/img/blog/ulgurji-naqdsiz-cover.webp",
            alt: "Оптовый склад и экран планшета со статусами оплат дилеров",
            caption: "Когда наличные уходят, контроль переезжает на экран",
            prompt:
                "Wholesale warehouse scene: pallets of boxed goods in the foreground, a manager with a tablet showing a payment-status dashboard where several dealer rows are marked paid and overdue; industrial daylight, muted blue-grey palette, no readable brands, 16:9",
        },
        {
            src: "/assets/img/blog/ulgurji-naqdsiz-oqim.webp",
            alt: "Сравнение прежней наличной схемы и новой безналичной схемы с ЭСФ",
            caption: "Сверху — прежняя модель, снизу — безналичная с электронными документами",
            prompt:
                "Process diagram comparing two flows: top row before with cash handover, paper waybill and manual ledger; bottom row after with bank transfer, e-invoice, automatic reconciliation in CRM and debt aging report; clean flat vector, red-to-green transition accent, 16:9",
        },
        {
            src: "/assets/img/projects/logistatrans.webp",
            alt: "Система LogistaTrans — заявки, маршруты и документы в одном окне",
            caption: "Пример реального проекта, где процесс дистрибуции переведён в цифру",
        },
        {
            src: "/assets/img/blog/ulgurji-naqdsiz-qarzdorlik.webp",
            alt: "Распределение дебиторской задолженности по срокам и средний срок оплаты",
            caption: "Отчёт по срокам: именно здесь видно, где застревают деньги",
            prompt:
                "Analytics panel illustration: accounts-receivable aging chart with buckets 0-30, 31-60, 61-90 and 90+ days, plus a KPI tile showing average days sales outstanding; minimal light dashboard, blue and amber accents, no logos, 16:9",
        },
    ],

    relatedServices: ["crm-tizimlar", "erp-tizimlar", "biznes-avtomatlashtirish"],
    relatedPosts: ["biznesni-raqamlashtirish-talablari-2026", "markirovka-kodi-chekda-2026", "shaxsiy-malumotlar-qonuni-sayt"],
};

const content = { uz, ru };

export default content;
